import { useEffect, useState } from "react";
import api from "../lib/api";

// Site images are optional settings: each public page keeps its existing image
// until an administrator chooses a replacement in the dashboard.
export function useSiteImages() {
  const [images, setImages] = useState({});

  useEffect(() => {
    api.get("/settings").then((response) => setImages(response.data || {})).catch(() => setImages({}));
  }, []);

  return (key, fallback) => images[key] || fallback;
}
